import React from "react";

const SectionTitle: React.FC<{
  id?: string;
  className?: string;
  children?: React.ReactNode;
}> = ({ className = "", id, children }) => (
  <div id={id} className={`mb-8 items-center gap-[60px] lg:flex ${className}`}>
    <hr className="hidden h-1 w-full grow rounded-sm border-none bg-clhbid-orange lg:block" />
    <h1 className="shrink-0 text-center text-3xl font-bold">{children}</h1>
    <hr className="hidden h-1 w-full grow rounded-sm border-none bg-clhbid-orange lg:block" />
  </div>
);

export default SectionTitle;
